<template>
  <div class="loginWarp">
    <div class="loginHeader">
      <ag-backHome></ag-backHome>
      <div class="loginBoxWarp" style="text-align: center">
        <div class="titleWarp">
          <span class="title">
            登录
          </span>
        </div>
        <div class="inputBox">
          <div class="inputWarp">
            手机号 <input type="number" v-model="m" placeholder="请输入手机号">
            <span class="clear"@click="m = ''">x</span>
          </div>
          <div class="inputWarp">
            密码 &nbsp;&nbsp;&nbsp;&nbsp;<input type="password" v-model="pas" placeholder="请输入密码">
          </div>
          <div class="inputWarp code loginCode" >
            验证码 <input type="text"v-model="cod" placeholder="请输入验证码">
          </div>
          <picCode class="loginPicCode" v-on:getCode="setCode"></picCode>
          <div class="loginBtn" @click="goLogin">登录</div>
        </div>
        <div class="forgetPassWord" @click="forgetPassWord('forgetPassWord')">忘记密码</div>
        <div class="goRegister" @click="forgetPassWord('register')">没有账号？<span class="colorde7a0e">马上注册 <img src="../../../assets/images/de7a0e.png" alt=""></span></div>
      </div>
    </div>
    <ag-footer></ag-footer>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'
  import picCode from '../../modules/picCode.vue'
  export default {
    data(){
      return{
        m:'',
        pas:'',
        cod:'',
        picCodee:''
      }
    },
    computed:{
      ...mapGetters([
        "gUserInfo"
      ])
    },
    components:{
      picCode
    },
    methods:{
      ...mapActions([
        "aUserInfo"
      ]),
      forgetPassWord(url){
        this.$router.push('/'+url)
      },
      setCode(data) {
        this.picCodee = data.code;
      },
      goLogin(){
        let _this = this;
        if(_this.picCodee!=_this.cod){
          this.$message({
            message: '图形验证码错误，请重新输入!',
            type: 'warning'
          });
        }else {
          _this.ajpost('/api/account/login',{mobile:_this.m,password:_this.pas},function (data) {
            if(data.code!='0'){
              _this.$message({
                message: data.msg,
                type: 'error'
              })
            }else {
              _this.setCookie('userInfo',JSON.stringify(data.data),1);
              _this.aUserInfo(data.data);
              _this.$router.push('/lIndex')
              _this.$message({
                message: '登录成功',
                type: 'success'
              });
            }
          },function (err) {
            console.log(err)
          })
        }
      }
    }
  }
</script>
<style>
  @import "../../../assets/less/loginHeader.css";
  .clear{
    width: 15px;height: 15px;
    background:url("../../../assets/images/icon_clean.png") no-repeat;
    display: inline-block;
    vertical-align: middle;
    margin-left: 37px;
    border-radius: 50%;
    color: #ffffff;
    font-size: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/login/login.vue